import React from 'react';

const VSvgLockIcon = ({ className, width = '16', height = '16' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} width={width} height={height} viewBox="0 0 16 16" fill="none">
            <path d="M12 5.33366H13.3333C13.7015 5.33366 14 5.63214 14 6.00033V14.0003C14 14.3685 13.7015 14.667 13.3333 14.667H2.66667C2.29848 14.667 2 14.3685 2 14.0003V6.00033C2 5.63214 2.29848 5.33366 2.66667 5.33366H4V4.66699C4 2.45785 5.79086 0.666992 8 0.666992C10.2091 0.666992 12 2.45785 12 4.66699V5.33366ZM7.33333 10.4886V12.0003H8.66667V10.4886C9.0652 10.2581 9.33333 9.82719 9.33333 9.33366C9.33333 8.59726 8.7364 8.00033 8 8.00033C7.2636 8.00033 6.66667 8.59726 6.66667 9.33366C6.66667 9.82719 6.9348 10.2581 7.33333 10.4886ZM10.6667 5.33366V4.66699C10.6667 3.19423 9.47273 2.00033 8 2.00033C6.52724 2.00033 5.33333 3.19423 5.33333 4.66699V5.33366H10.6667Z" fill="currentColor" />
        </svg>
    )
}

export default VSvgLockIcon;

